import script from "./OrganismsBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsBar.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsBar.vue?vue&type=style&index=0&id=52f88d1b&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f88d1b"]])

export default __exports__